import { useState, useEffect } from 'react';
import axios from 'axios';

const useIAProfileCounts = () => {
  const [counts, setCounts] = useState({
   
    iaTraining: 0,

   
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);  // Initialize setError here

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const response = await axios.get('https://niaserver-05287f289508.herokuapp.com/iaTraining/getCounts');
        setCounts({
         
          iaTraining: response.data.iaTraining || 0,
          
        });
        setLoading(false);
      } catch (err) {
        setError(err.message);  // setError is now properly defined
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return { counts, loading, error };  // Return the error along with the other states
};

export default useIAProfileCounts;
